import PropTypes from "prop-types"
import React from "react"
import "../components/buttons.css" 

const Button = ( {buttonname, buttoncolor, buttonwidth, link} ) => (
    <table style={{borderWidth: '2px',
                   borderStyle: 'solid',
                   borderColor: buttoncolor,
                   borderCollapse: 'collapse',
                   width: buttonwidth,
                   color: {buttoncolor},
                   }}>
        <tbody>
            <tr>
                <td style={{color: {buttoncolor}, textAlign: 'left', paddingLeft: '2rem', border: '0px solid black', borderCollapse: 'collapse'}}>
                <a class="ex1" href={link} style={{color: buttoncolor}}>{buttonname}</a>
                </td>
            </tr>
        </tbody>
    </table>
)


Button.propTypes = {
    buttonname: PropTypes.string.isRequired,
    buttoncolor: PropTypes.string.isRequired,
    buttonwidth: PropTypes.string,
    link: PropTypes.string.isRequired,
}
  
Button.defaultProps = {
    buttonname: ``,
    buttoncolor: `white`,
    solid: 'false',
    buttonwidth: '10%',
    link: '/',
}

export default Button